<template>
  <div class="panel-root stack tight">
    <UiSectionHeader>
      <template #title>{{ ICONS.inspectKinds.npc }} NPCs</template>
      <template #actions>
        <UiChip variant="muted" class="stat-mono num">{{ formatNumber(npcs.length) }}</UiChip>
      </template>
    </UiSectionHeader>

    <UiCallout v-if="npcs.length === 0" variant="info">No NPCs here.</UiCallout>

    <div v-else class="list panel-scroll scroll">
      <NpcRow
        v-for="npc in npcs"
        :key="npc.id"
        :npc="npc"
        :disabled="disabled"
        @engage="emit('engage', $event)"
        @trade="emit('trade', $event)"
        @talk="emit('talk', $event)"
        @influence="emit('influence', $event)"
        @inspect="emit('inspect', $event)"
        @steal="emit('steal', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Npc } from "@idle-rpg/shared";
import { ICONS } from "../../lib/icons";
import { formatNumber } from "../../lib/format";
import NpcRow from "../world/rows/NpcRow.vue";
import UiCallout from "../ui/UiCallout.vue";
import UiChip from "../ui/UiChip.vue";
import UiSectionHeader from "../ui/UiSectionHeader.vue";

defineProps<{
  npcs: Npc[];
  disabled?: boolean;
}>();

const emit = defineEmits<{
  engage: [npcId: string];
  trade: [npc: Npc];
  talk: [npc: Npc];
  influence: [npc: Npc];
  inspect: [npc: Npc];
  steal: [npc: Npc];
}>();
</script>

<style scoped>
.panel-root {
  min-width: 0;
}

.list {
  display: grid;
  gap: 0.6rem;
}
</style>
